import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useRegisterMutation } from "../slices/usersApiSlice";
import { setCredentials } from "../slices/authSlice";
import "./css/Login.css";
import { Link } from "react-router-dom";
import { Button, Col, Flex, Input, Row, Space, Typography, notification } from "antd";
import Logo from "../images/Lincfolio.png";
import Laptop from "../images/laptop.png";
import { KeyOutlined, MailOutlined, ProfileOutlined, SignatureOutlined } from "@ant-design/icons";
import { motion } from "framer-motion"

const RegisterScreen = () => {
  const [api, contextHolder] = notification.useNotification();
    const [searchParams] = useSearchParams();
  const [sponsorId, setSponsorId] = useState("");

  useEffect(() => {
    const sponsor = searchParams.get("sponsor");
    if (sponsor) {
      setSponsorId(sponsor);
    }
  }, [searchParams]);
const {id}=useParams();
console.log(id);

  const { Title, Text } = Typography;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [register, { isLoading }] = useRegisterMutation();

  const [show, setShow] = useState(false);

  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
// const [sponsorId, setSponsorId] = useState("")
  const [passwordVisible, setPasswordVisible] = useState(false);


  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      const res = await register({ firstname, lastname, email, password ,sponsorId}).unwrap();
      dispatch(setCredentials({ ...res }));
      navigate("/Dashboard");
    } catch (err) {
      api.error({
        message: err?.data?.message || err.error || err?.data?.error,
      });
    }
  }
  return (
    <>
      {contextHolder}
      <form onSubmit={(e) => handleRegister(e)}>
        <Flex align="center" className="login-background" style={{ height: "100vh" }} >
          <Row justify="space-around" style={{ width: "100%" }}>
            <Col xs={{ span: 22, order: 2 }} lg={{ span: 6, order: 1, offset: 2 }} className="background-blur" style={{ padding: "20px", height: "370px", boxShadow: '0px 3px 6px 0px rgba(0, 0, 0, 0.12)' }}>
              <h1>Register</h1>

              <Space direction='vertical' style={{ width: "100%" }}>
                <Input placeholder="First Name" addonBefore={<ProfileOutlined />} onChange={(e) => setFirstname(e.target.value)} required />
                <Input placeholder="Last Name" addonBefore={<ProfileOutlined />} onChange={(e) => setLastname(e.target.value)} required />
                <Input placeholder="Email" addonBefore={<MailOutlined />} onChange={(e) => setEmail(e.target.value)} required />
                <Input.Password placeholder="Password" addonBefore={<KeyOutlined />} onChange={(e) => setPassword(e.target.value)} visibilityToggle={{ visible: passwordVisible, onVisibleChange: setPasswordVisible }} required />
                <Input
  placeholder="Sponsor / Referral Code (optional)"
  addonBefore={<ProfileOutlined />}
  value={sponsorId}
  // onChange={(e) => setSponsorId(e.target.value)}
/>
                <Button type="primary" htmlType="submit">Register <SignatureOutlined /></Button>
                <Flex justify="start">
                  <p>Already have an account? Login <Link to={"/login"}> here!</Link></p>
                </Flex>
              </Space>
            </Col>
            <Col xs={{ span: 22, order: 1 }} lg={{ span: 16, order: 2 }} style={{ padding: "20px", textAlign: "center" }}>
              {/* <motion.div initial={{ y: 100, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ ease: "easeOut", duration: 2 }}>
                <img src={Logo} alt="Lincfolio" className="logo" /><br />
              </motion.div>
              <motion.div initial={{ y: 100, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ ease: "easeOut", duration: 2, delay: 0.5 }}>
                <img src={Laptop} alt="Lincfolio-Laptop" className="laptop" /><br />
              </motion.div> */}
              {/* <motion.div initial={{ y: 100, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ ease: "easeOut", duration: 2, delay: 1 }}>
                <p style={{ fontSize: "18pt" }}>"Lincfolio, your trading tool, making profits easy and cool!"</p><br />
              </motion.div> */}
            </Col>
          </Row>
        </Flex>
      </form>
    </>
  )
};
export default RegisterScreen;

